import gql from 'graphql-tag'

export const initStatisticsData = gql`
query initLoyaltyCardStats($params: StatisticLoyaltyCardInput) {
	cashAssist {
		initLoyaltyCardStats(params: $params)
	}
}
`

export const getStatisticsData = gql`
query getStatisticsData($requestId: ID!) {
	cashAssist {
		getStatisticsData(requestId: $requestId) {
			status
			data {
				... on StatisticLoyaltyCard {
					id
					cardId
					cardName
					dateTime
					cashRegisterId
					cashRegisterName
					billNumber
					userName
					transactionName
					group
					total
					type
				}
			}
		}
	}
}
`
